/**
 * Angular import.
 */
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
/**
 * Owl Carousel options import.
 */
import { OwlOptions } from 'ngx-owl-carousel-o';
/**
 * Services imports.
 */
import { GetService } from './../../dataservices/get.service';
import { FunCollectionService } from './../../common/common-functions/fun-collection.service';
import { NewLanguageService } from './../../dataservices/new-language/new-language.service';
import { DataStorageService } from './../../dataservices/data-storage.service';
import { MasterserviceService } from './../../dataservices/master-service/masterservice.service';
import { PostApiService } from '../../dataservices/post-api.service';
import { JwtDecodeService } from '../../dataservices/jwt-decode.service';
import { AnalyticsInterface } from '../../analytics-event/analytics.model';
import { AnalyticsEventService } from '../../analytics-event/analytics-event.service';
/**
 * RxJs import.
 */
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
/**
 * Constants import.
 */
import { ERROR_CODES, NUMBERS, PRODUCT_TYPE_CONSTANT, SCREEN_NAME, SPECIAL_CHARACTER } from './../../constants/app.constants';
import { EVENT_NAME } from '../../analytics-event/analytics.constant';
/**
 * Interfaces import.
 */
import { LikeObject, NcpProduct, Template } from './../model/ncp.model';
import { userComment } from '../../onboarding/interface/global.model';


@Component({
  selector: 'app-game-detail',
  templateUrl: './game-detail.component.html',
  styleUrls: ['./game-detail.component.scss']
})
export class GameDetailComponent implements OnInit, OnDestroy {
  /**
   * Necessary instance.
   */
  constructor(
    private getService: GetService,
    private fcs: FunCollectionService,
    private router: Router,
    private route: ActivatedRoute,
    public Dss: DataStorageService,
    private masterService: MasterserviceService,
    private postService: PostApiService,
    private jwtService: JwtDecodeService,
    private location: Location,
    public mls: NewLanguageService,
    private analyticsEventService: AnalyticsEventService
  ) { }

  /**
   * Comment object.
   */
  public comment_box_obj = { profile_pic: '', product_type_id: '', product_id: '' };
  /**
   * Comment object data.
   */
  public commentObj;
  /**
   * Game product in NCP.
   */
  public gameNCPProduct: NcpProduct;
  /**
   * Like object data.
   */
  public likeObject: LikeObject;
  /**
   * Game template object.
   */
  public gameDetailTemplate: Template;
  /**
   * Product id.
   */
  public ncpProductId: number;
  /**
   * Store error message text.
   */
  public errorMessage: string;
  /**
   * Api loading status.
   */
  public isFinished = false;
  public loader = false;
  /**
   * Constant import.
   */
  public numbers = NUMBERS;
  public specialCharacter = SPECIAL_CHARACTER;
  public screenName = SCREEN_NAME.NCP_SUBTYPE_DETAIL_PAGE;
  /**
   * To unsubscribe data.
   */
  private subscriptions: Subscription = new Subscription();
  /**
   * Product type constants.
   */
  public productType = PRODUCT_TYPE_CONSTANT;

  /**
   * @notifier$ defines a notifier subject stream to end data streaming
   */
  private notifier$ = new Subject();

  /**
   * Owl carousel options.
   */
  public customOptions: OwlOptions = {
    loop: false,
    mouseDrag: false,
    touchDrag: true,
    pullDrag: true,
    dots: false,
    navSpeed: 700,
    navText: ['<i class="prev-slider position-absolute"></i>', '<i class="next-slider position-absolute"></i>'],
    nav: true,
    autoWidth: true,
    autoplay: false,
    responsive: {
      0: {
        items: 1.2,
        margin: 15,
      },
      405: {
        items: 1.45,
        margin: 15
      },
      585: {
        items: 1.45,
        margin: 20,
      },
      600: {
        items: 1.45,
        margin: 20
      }
    }
  };
  /**
   * Variable to show Like list.
   */
  public showLikeListModal: boolean;

  /**
   * Analyticsdata object.
   */
  private analyticsData: AnalyticsInterface;
  public analyticsPlayNowData: AnalyticsInterface;
  public analyticsLikeData: AnalyticsInterface;
  public analyticsCommentData: AnalyticsInterface;
  public analyticsShareData: AnalyticsInterface;
  public sessiontime = { 'start_time': '', 'end_time': '' };

  /**
   * Emit user comment.
   */
  public emitUserComment: userComment;
  /**
   * NCP detail screen name.
   */
  public ScreenName = SCREEN_NAME.NCP_SUBTYPE_DETAIL_PAGE;

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.ncpProductId = params['id'];
      if (this.ncpProductId) {
        const dateObj = new Date();
        this.sessiontime.start_time = dateObj.getTime().toString();
        this.sendAnalyticEvent();
        this.gameDetails(this.ncpProductId);
        this.generateAnalyticsData();
      }
    });

  }

  /**
   * Reset comment.
   */
  resetComment(): void {
    this.commentObj.total_comment += this.numbers.ONE;
    this.gameNCPProduct.count.comment += this.numbers.ONE;
  }
  /**
   * Reset comment list.
   */
  resetCmtList(): void {
    this.commentObj.total_comment -= this.numbers.ONE;
    this.gameNCPProduct.count.comment -= this.numbers.ONE;
  }
  /**
   * create comment object.
   */
  initializeCommentObj(): void {
    this.commentObj = {
      product_id: this.gameNCPProduct.product_type_id,
      product_type: this.gameNCPProduct.product_type,
      comment: [],
      total_comment: this.numbers.ONE,
      kind: ''
    };
  }

  /**
   * Get comment data.
   */
  getCommentList(): void {
    this.subscriptions.add(this.getService.getProductCommentList(this.numbers.FOURTY_NINE, this.gameNCPProduct.product_type, this.numbers.ONE).subscribe(resData => {
      this.jwtService.decodeData(resData).then(data => {
        if (data.status == this.numbers.ONE) {
          this.commentObj = {
            comment_flag: this.numbers.ONE,
            product_id: this.gameNCPProduct.product_type_id,
            product_type: this.productType.NCP_SUB_TYPE,
            comment: [],
            total_comment: data.data.total_count,
            kind: ''
          };
        } else {
          this.fcs.errorHandeler(data);
        }
      });
    }));
  }

  /**
   * Function used to scroll body to a particular block.
   */
  scroll(className: string): void {
    const elementList = document.querySelectorAll('.' + className);
    const element = elementList[0] as HTMLElement;
    element.scrollIntoView({ behavior: 'smooth' });
  }

  /**
   * Move to Game Screen.
   */
  navigateToGameScreen(): void {
    this.updatePlayCount();
  }

  /**
   * Load the Game details.
   */
  gameDetails(ncpProductId: number): void {
    this.isFinished = true;
    this.subscriptions.add(this.getService.gameDetails(ncpProductId).subscribe(detail => {
      this.isFinished = false;
      this.errorMessage = '';
      if (detail.status === NUMBERS.ONE) {
        this.gameNCPProduct = detail.data.ncp_product[0];
        this.gameDetailTemplate = this.gameNCPProduct.template;
        this.comment_box_obj.product_type_id = this.gameNCPProduct.product_type.toString();
        this.comment_box_obj.product_id = this.gameNCPProduct.product_type_id.toString();
        this.comment_box_obj.profile_pic = this.Dss.user_profile_data.profile_pic;
        this.initializeCommentObj();
      } else if (detail.status === NUMBERS.ZERO) {
        this.gameNCPProduct = null;
        this.fcs.errorHandeler(detail);
        if (detail.error.code === ERROR_CODES.RESTRICTED_CONTENT_ERROR_CODE) {
          this.errorMessage = this.fcs.displayObj.data['pre_document_card'].description_text;
        } else {
          this.errorMessage = detail.error.msg;
        }
      }
    }, err => {
      this.isFinished = false;
      this.errorMessage = err.message;
    }));
  }

  /**
   * Leader board list.
   */
  leaderBoard(ncpProductId: number): void {
    this.subscriptions.add(this.getService.getLeaderBoard(1, ncpProductId).subscribe(leaderBoard => {
      if (leaderBoard.status === NUMBERS.ONE) {
        console.log('....', leaderBoard);
      } else if (leaderBoard.status === NUMBERS.ZERO) {
        this.fcs.errorHandeler(leaderBoard);
        this.errorMessage = leaderBoard.error.msg;
      }
    }, err => {
      this.errorMessage = err.message;
    }));
  }

  /**
   * like product
   */
  likeProduct(): boolean {
    if (this.masterService.isOnline == false) {
      this.masterService.isConnectionModalShown.next('1');
      return false;
    }
    if (this.loader === true) {
      return;
    }
    if (this.gameNCPProduct.is_liked === NUMBERS.ONE) {
      return;
    }
    this.loader = true;
    this.subscriptions.add(this.postService.productLike(this.gameNCPProduct.product_type,
      this.gameNCPProduct.product_type_id, 'like').subscribe(response => {
        this.loader = false;
        this.jwtService.decodeData(response).then(data => {
          if (data['status'] === NUMBERS.ONE) {
            this.fcs.showSuccess(data['msg'], 'Success');
            this.gameNCPProduct.is_liked = this.numbers.ONE;
            this.gameNCPProduct.count.like = this.gameNCPProduct.count.like + this.numbers.ONE;
          } else if (data['status'] === NUMBERS.ZERO) {
            this.fcs.errorHandeler(data);
            return;
          }
        }, () => {
          this.loader = false;
        });
      }));
  }

  /**
   * Share Product
   */
  shareProduct(): boolean {
    if (this.masterService.isOnline == false) {
      this.masterService.isConnectionModalShown.next('1');
      return false;
    }

    const share = [{
      share_url: '',
      share_content: '',
      product_type: this.gameNCPProduct.product_type,
      product_type_id: this.gameNCPProduct.product_type_id
    }];
    this.fcs.productShare(share);
  }

  /**
   * Go to previous screen.
   */
  goBack(): void {
    this.location.back();
  }

  /**
   * unsubscribe the subscription.
   */
  ngOnDestroy(): void {
    if (this.subscriptions) {
      this.subscriptions.unsubscribe();
    }
    this.notifier$.next();
    this.notifier$.complete();
    this.sessiontime.end_time = new Date().getTime().toString();
    this.analyticsData = {
      'event_name': EVENT_NAME.NCP_SUBTYPE_VISIT,
      'product_type': PRODUCT_TYPE_CONSTANT.NCP_SUB_TYPE,
      'product_type_id': this.ncpProductId,
      'screen_name': SCREEN_NAME.NCP_SUBTYPE_DETAIL_PAGE,
      'start_time': this.sessiontime.start_time,
      'end_time': this.sessiontime.end_time
    };
    this.analyticsEventService.logAnalyticsEvent(this.analyticsData);
  }

  /**
 * @EventHandler to capture play count and redirect to game screen
 */
  updatePlayCount(): void {
    this.postService.updatePlayCount(this.gameNCPProduct.product_type_id).
      pipe(takeUntil(this.notifier$)).
      subscribe(response => {
        this.jwtService.decodeData(response).then(data => {
          if (data['status'] === NUMBERS.ONE) {
            this.fcs.validateTargetType(this.gameNCPProduct.target, this.gameNCPProduct.product_type_id);
          } else if (data['status'] === NUMBERS.ZERO) {
            // No Code
          }
        }, error => {
          console.log(error);
        });
      });
  }

  /**
   * getter for specialty count
   */
  get specialtyCount(): string {
    return this.gameNCPProduct.specialities.length > NUMBERS.ONE ? ` +${this.gameNCPProduct.specialities.length - 1}` : '';
  }

  /**
   * getter for specialty title
   */
  get specialtyTitle(): string {
    let title = '';
    this.gameNCPProduct.specialities.map((specialty) => {
      title += `${specialty.speciality_name},`;
    });
    return title.slice(0, -1);
  }

  /**
   * @EventHandler to get product Like List
   */
  getProductLikeList(): boolean {
    if (this.masterService.isOnline == false) {
      this.masterService.isConnectionModalShown.next('1');
      return false;
    }

    this.likeObject = {
      'product_id': this.gameNCPProduct.product_type_id,
      'product_type': this.gameNCPProduct.product_type,
      'callLikeProperty': 'list'
    };
    this.showLikeListModal = true;
    return true;
  }

  /**
   * @EventHandler reset Like
   */
  resetLike(): void {
    this.loader = false;
    this.showLikeListModal = false;
  }

  /**
   * @EventHandler for sending analytic event
   */
  sendAnalyticEvent(): void {
    const events = [EVENT_NAME.NCP_SUBTYPE_ENTRY];
    for (const event of events) {
      this.analyticsData = {
        'event_name': event,
        'product_type': PRODUCT_TYPE_CONSTANT.NCP_SUB_TYPE,
        'product_type_id': this.ncpProductId,
        'screen_name': SCREEN_NAME.NCP_SUBTYPE_DETAIL_PAGE,
        'start_time': this.sessiontime.start_time,
        'end_time': this.sessiontime.start_time
      };
      this.analyticsEventService.logAnalyticsEvent(this.analyticsData);
    }
  }

  generateAnalyticsData(): void {
    const events = {
      'analyticsPlayNowData': EVENT_NAME.GET_STARTED_CLICK,
      'analyticsLikeData': EVENT_NAME.NCP_LIKE_CLICK,
      'analyticsCommentData': EVENT_NAME.NCP_CARD_COMMENT_CLICK,
      'analyticsShareData': EVENT_NAME.NCP_SHARE_CLICK
    };
    // tslint:disable-next-line: forin
    for (const event in events) {
      this[event] = {
        'event_name': events[event],
        'product_type': PRODUCT_TYPE_CONSTANT.NCP_SUB_TYPE,
        'product_type_id': this.ncpProductId,
        'screen_name': SCREEN_NAME.NCP_SUBTYPE_DETAIL_PAGE,
      };
    }
  }

  /**
   * Emit user comment.
   */
  emitComment(data: userComment): void {
    this.emitUserComment = data;
  }

}
